module.exports = __webpack_public_path__ + "images/emails/bg-page-t-2e3cb1ae.gif";